import { spreadAndtransformDefaultValues } from '@common/components/forms';
import { PageCard, PageCardProps } from '@common/components/layout';
import { Pager } from '@common/components/pagination';
import { useApp } from '@common/hooks';
import { HospitalModel } from '@common/models/HospitalModel';
import { IUserSearchOrgFilter, UserSearchStore } from '@hospital/stores';
import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Form, FormGroup, InputGroup } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { UsersTable } from '../userprofile';

export type ILocationDetailUsersListProps = {
    hospital: HospitalModel
    userProfileBaseUrl: string
} & PageCardProps

export const LocationDetailUsersList = observer(({ hospital, userProfileBaseUrl, ...cardProps }: ILocationDetailUsersListProps) => {
    const { configuration } = useApp();
    const navigate = useNavigate();
    const [userSearchStore] = useState<UserSearchStore>(new UserSearchStore({
        scope: 'org',
        organizationVersionId: configuration.currentCorpOrganization.organizationVersionId,
        organizationSourceId: configuration.currentCorpOrganization.organizationSourceId,
        organizationRelationKey: hospital.organizationRelationKey

    }));
    const { register, reset, handleSubmit } = useForm<IUserSearchOrgFilter>({
        shouldFocusError: true,
        defaultValues: spreadAndtransformDefaultValues(userSearchStore.searchFilter)
    });
    useEffect(() => {
        userSearchStore.search();
    }, [userSearchStore, userSearchStore.combinedSearchParams]);


    const removeAllFilters = useCallback(() => {
        if (userSearchStore) {
            userSearchStore.resetSearchFilter();
            reset(spreadAndtransformDefaultValues(userSearchStore.searchFilter));
        }
    }, [userSearchStore, reset]);


    const userClick = useCallback((userId: number) => {
        navigate(`${userProfileBaseUrl}${userId}`);
    }, [navigate, userProfileBaseUrl]);

    return (
        <PageCard title="Location Access" {...cardProps}>
            <Form onSubmit={handleSubmit(userSearchStore.updateSearchFilter)}>
                <FormGroup>
                    <InputGroup>
                        <Form.Control aria-label="Search By First Name" type="text" placeholder='Search by first name' {...register("firstName")} id="locationDetailAccessUserSearchFirstName" />
                        <Form.Control aria-label="Search By Last Name" type="text" placeholder='Search by last name' {...register("lastName")} id="locationDetailAccessUserSearchLasttName" />
                        <Button type="button" onClick={removeAllFilters} variant="outline-primary" id="locationDetailAccessUserClearSearchButton"><i className="fa fa-times"></i></Button>
                        <Button type="submit" variant="primary" id="locationDetailAccessUserSearchButton">Search</Button>
                    </InputGroup>
                </FormGroup>
            </Form>
            <UsersTable userSearchStore={userSearchStore} noUsersMessage='There are no users assigned to this location.' hideEmail={true} combineFirstLastName={true} onClick={userClick} />
            {userSearchStore.hasMultiplePages &&
                <Pager
                    skip={userSearchStore.searchParams.skip}
                    totalItems={userSearchStore.searchResults.totalRecordCount}
                    pageSize={userSearchStore.searchParams.top}
                    onPageChange={userSearchStore.changePage} />
            }
        </PageCard>
    )
});
